module.exports = __webpack_public_path__ + "img/video.1ba47854.png";